export default {
  // ========== Matrix3View - Títulos y textos ==========
  tributationOf: 'Tributación de las',
  to: 'al',
  definition: 'Definición:',
  planLevel: 'Nivel del Plan',
  goTo: 'Ir al',
  viewDetails: 'Ver Detalles',
  editSubjectsOfCompetence: 'Editar Asignaturas de la Competencia',
  competence: 'Competencia:',
  closed: '(Cerrada)',
  updated: 'actualizada',
  planOf: 'Plan de',
  level: 'Nivel',
  noCompetencesThatContribute: 'No hay {competences} que tributen a este {egressProfile}.',
  without: 'sin',
  with: 'con',
  selected: 'seleccionado',

  // ========== Mensajes específicos ==========
  selectSubjectsThatContribute: 'Selecciona las {subjects} que contribuyen a esta {competence}',

  // ========== AI Features ==========
  suggestTributationWithAI: 'Sugerencias de tributación de {entity1} a {entity2} con IA',
  suggestTributation: 'Sugerencias de tributación de {entity1} a {entity2}',
  suggestTributationDemo: 'Sugerir tributación',
  analyzeCurriculumCoherenceWithAI: 'Analizar la coherencia del currículum con IA',
  analyzeCurriculumCoherenceDemo: 'Analizar Coherencia Curricular',
  loadingSuggestions: 'Cargando sugerencias',
  regenerating: 'Regenerando',
  regenerateSuggestions: 'Regenerar Sugerencias',
  generatingSuggestions: 'Generando sugerencias de tributación',
  tributationSuggestions: 'Sugerencias de Tributación',
  printSuggestionsReport: 'Imprimir reporte de sugerencias',
  print: 'Imprimir',
  curriculumCoherenceAnalysis: 'Análisis de Coherencia Curricular',
  loadingAnalysis: 'Cargando análisis',
  regenerateAnalysis: 'Regenerar Análisis',
  analysisParameters: 'Parámetros del Análisis',
  temperatureCreativity: 'Temperatura (Creatividad)',
  maxTokens: 'Máximo de tokens',
  recommendedPreciseAnalysis: 'Recomendado: 0.2 para análisis preciso y coherente',
  recommendedCompleteAnalysis: 'Recomendado: 2000-6000 para análisis completo',
  generatingAnalysis: 'Generando análisis',
  analysisResult: 'Resultado del Análisis',
  printAnalysisReport: 'Imprimir reporte de análisis',
  cancelGeneration: 'Cancelar Generación',
  analysisInProgress: 'La generación del análisis está en progreso. ¿Deseas cancelar y cerrar el modal?',
  suggestionsInProgress: 'La generación de sugerencias está en progreso. ¿Deseas cancelar y cerrar el modal?',
  yesCancel: 'Sí, cancelar',
  noContinue: 'No, continuar',
  maxLengthReached: 'La generación alcanzó el límite de longitud máxima. {type} puede estar incompleto',
  contentFiltered: 'El contenido fue filtrado por considerarse inapropiado',
  couldNotDetermineResult: 'No se pudo determinar un resultado completo. {action} nuevamente',
  adjustParametersAndRetry: 'Ajusta los parámetros e intenta nuevamente',
  retry: 'Intenta nuevamente',
  errorGenerating: 'Ocurrió un error al generar {type}. Por favor, intenta nuevamente',
  theAnalysis: 'el análisis',
  theSuggestions: 'las sugerencias',
  analysis: 'Análisis',
  suggestions: 'Sugerencias',
  analysisMayBeIncomplete: 'El análisis mostrado puede estar incompleto',
  suggestionsMayBeIncomplete: 'Las sugerencias mostrado puede estar incompleto',
}
